<template>
  <div id='action-sheet' @click.self="close">
    <div id="action-sheet-container">
      <div id='action-sheet-content' ref='actionSheetContent'>
        <div v-for="(item, index) in options" :key="index" :class="index == currentOption ? 'selected':''" @click="select(index)">
          {{ item }}
        </div>
      </div>
      <div id='action-sheet-close-btn' @click.self="close">{{ $t('common.cancel') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'action-sheet',
  props: {
    options: {
      type: Array, // [title]
      require: true,
      default: function () {
        return [
          'A',
          'B',
          'C'
        ]
      }
    },
    currentOption: {
      type: Number, // index
      default: () => 0
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow (newValue) {
      if (newValue) {
        this.$nextTick(function () {
          this.$refs.actionSheetContent.childNodes[this.currentOption].scrollIntoView()
        })
      }
    }
  },
  methods: {
    close: function (event) {
      this.$emit('close', event)
    },
    select: function (index) {
      this.$emit('selected', index)
      this.$emit('close', event)
    }
  }
}
</script>

<style lang="sass">
@import '~@/styles'

#action-sheet
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  z-index: 9998
  background-color: rgba(0, 0, 0, .60)
  font-size: 16px
  text-align: center

$margin: 8px
#action-sheet-container
  position: absolute
  bottom: 0
  text-align: center
  width: 100%
  vertical-align: middle
  background-color: #e6e6e6

%itemStyle
  height: 44px
  line-height: 44px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap

#action-sheet-content
  margin-bottom: $margin
  color: #333333
  overflow-y: auto
  max-height: 65vh

  > div // option items
    background-color: #f4f4f4
    padding: 0 15px
    @extend %itemStyle

  > div:not(:last-child)
    margin-bottom: 1px

#action-sheet-close-btn
  @extend %itemStyle
  color: #999999
  background-color: #ececec

.selected
  color: #ff3333
</style>
